import { ContractWorkStatus } from '@apeiron/contract'
import * as yup from 'yup'

export const contractWorkStatusSchema: yup.BaseSchema<ContractWorkStatus> = yup
  .mixed()
  .oneOf(Object.values(ContractWorkStatus))
  .default(ContractWorkStatus.IDLE)
